import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { ADVISORY_DISPLAY_DURATION_IN_SECONDS } from '../../../../logic/player/video.constants';
import { getInitialStyle, defaultContext, getIconViewBox } from './contentAdvisory.style';
import { PICTO_MARGIN, TEMPLATE } from './contentAdvisory.constants';
import Icon from '../../../tornado/icon/icon.component';
import connect from './contentAdvisory.connector';

/**
 * This molecule is used to indicate the type of video content, and can be seen at the start of a video on the player.
 *
 * @version 2.5.3
 * @see https://zeroheight.com/726d5c282/v/0/p/6743bf-contentadvisory--v253
 */
export class ContentAdvisory extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Treatment: {},
        Content: TEMPLATE,
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._hasData = false;
    this._displayDuration = ADVISORY_DISPLAY_DURATION_IN_SECONDS * 1000;
    this._inProgress = false;
    this._timerId = null;
  }

  _build() {
    this._hide();
  }

  _attach() {
    this._unsubscribe = connect(this);
  }

  _detach() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }

    this._destroyTimer();
  }

  set contentAdvisory(value) {
    if (value) {
      this._setText(value.title, 'Title');
      this._setText(value.description, 'Description');
      this.pictos = value.pictos;
      this.tag('Treatment').visible = this._hasData;
    } else {
      this._hasData = false;
    }
  }

  set pictos(value) {
    if (!value) {
      return;
    }

    const iconViewBox = getIconViewBox(this._style.screenSize);
    const element = this.tag('Icons');

    element.children = value.filter(Boolean).map(picto => ({
      type: Icon,
      iconData: {
        picto,
        viewBox: iconViewBox,
      },
      flexItem: {
        marginRight: PICTO_MARGIN[this._style.screenSize],
      },
    }));

    this._hasData = this._hasData || Boolean(element.children.length);
  }

  _setText(value, tag) {
    const element = this.tag(tag);
    element.text.text = value;
    element.visible = Boolean(value);
    this._hasData = this._hasData || element.visible;
  }

  _show() {
    this.alpha = 1;
  }

  _hide() {
    this.alpha = 0;
  }

  _complete() {
    this._hide();
    this._inProgress = false;
  }

  _startTimer() {
    this._timerId = setTimeout(this._complete.bind(this), this._displayDuration);
  }

  _destroyTimer() {
    if (this._timerId) {
      clearTimeout(this._timerId);
      this._timerId = null;
    }
  }

  start() {
    this._show();
    this._startTimer();
    this._inProgress = true;
  }

  pause() {
    this._hide();
    if (this._inProgress) {
      this._destroyTimer();
    }
  }

  resume() {
    if (!this._inProgress) {
      this._hide();

      return;
    }

    this._show();
    this._startTimer();
  }
}
